import React from "react"
import classnames from "classnames"

const Mask = ({ isVisible }) => {
  return (
    <div
      className={classnames({
        mask: true,
        "mask--hide": !isVisible,
      })}
    ></div>
  )
}

export default Mask
